import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsAddPhotoAlternateOutline = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h8v2H5v14h14v-8h2v8q0 .825-.587 1.413T19 21zm1-4h12l-3.75-5-3 4L9 13zm11-8V7h-2V5h2V3h2v2h2v2h-2v2z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsAddPhotoAlternateOutline);
const Memo = memo(ForwardRef);
export default Memo;
